const getFormattedPropertyName = (key: string) => {
  return (propertyStringMap[key] as string).toUpperCase();
};

const propertyStringMap = {
  primaryAccentColor: 'Primary Color',
  primaryAccentTextColor: 'Primary Text Color',
  backgroundColor: 'Background Color',
  agentBubbleBackgroundColor: 'Agent bubble background Color',
  agentBubbleTextColor: 'Agent bubble text Color',
  bubbleBackgroundColor: 'Chat bubble background Color',
  bubbleTextColor: 'Chat bubble text Color',
  sendButtonBackgroundColor: 'Send button color',
  sendButtonTextColor: 'Icon color',
  suggestedResponseColor: 'Suggested besponse color',
  buttonBackgroundColor: 'Button background color',
  buttonTextColor: 'Button text color',
};

export default getFormattedPropertyName;
